import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SignupService } from 'src/app/common-service/signup.service';

@Component({
  selector: 'usermgt-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(public router:Router, public spinner: NgxSpinnerService, public signin: SignupService) { }

  ngOnInit(): void {
    if (JSON.parse(sessionStorage.getItem('userInfo-usec')).defaultRole.roleName !== 'System Admin') {
      this.router.navigate(['/']);
    }
  }
  
  logout() {
   this.clearSession();
  }

  clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  logoutAuditLog() {
    this.signin.getLogoutAuditLog().subscribe((res: any) => {
      this.signin.deleteOauthTokenLogout().subscribe((result: any) => {      
      });      
    },
    error => {
     console.log(error);
    });
  }

}
